/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Calendar_Empty_TitleInputs */

const en_landing_calendar_empty_title = /** @type {(inputs: Landing_Calendar_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online booking is not open yet`)
};

const pl_landing_calendar_empty_title = /** @type {(inputs: Landing_Calendar_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwacja online nie jest jeszcze otwarta`)
};

/**
* | output |
* | --- |
* | "Online booking is not open yet" |
*
* @param {Landing_Calendar_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_calendar_empty_title = /** @type {((inputs?: Landing_Calendar_Empty_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Calendar_Empty_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_calendar_empty_title(inputs)
	return en_landing_calendar_empty_title(inputs)
});